import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

import { withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import { ToastContainer, toast } from "react-toastify";

import * as Constants from "./Constants";

const baseUrl = Constants.URL();

function DeleteNewsletterConfirm({ match }) {
  const history = createBrowserHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [post, setPost] = React.useState(null);
  const [id, setId] = React.useState(match.params.id);
  const toastId = React.useRef(null);

  const onSubmit = function () {
    axios
      .post(`${baseUrl}Newsletters/Delete`, id)
      .then((response) => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success("Submitted Successfully", {
            toastId: "success",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: false,
            draggable: false,
            progress: undefined,
            theme: "light",
            draggablePercent: 0,
          });

          const location = {
            pathname: `/Newsletters`,
            state: { fromDashboard: true },
          };

          history.push(location);

          setTimeout(() => window.location.reload(), 3800);
        }
      })
      .catch((err) => {
        console.error(err);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Submission failed", {
            toastId: "failed",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: false,
            draggable: false,
            progress: undefined,
            theme: "light",
            draggablePercent: 0,
          });
        }
      });
  };

  const onCancel = function () {
    const location = {
      pathname: `/Newsletters`,
      state: { fromDashboard: true },
    };

    history.push(location);

    window.location.reload();
  };

  return (
    <div className="Card u-marginAuto u-marginBottom20">
      <div className="Card-content u-marginTop10">
        <input
          className="customInput"
          type="hidden"
          name="csrfmiddlewaretoken"
          value="0aiY5RDRupxjz3ITP49uNZ3YYfET3oeBn3RewbVyTP1JNRJIwc6YRdCACn9UbrQr"
        />
        <h2 className="Card-title u-marginBottom20">
          Delete Newsletter Confirm
        </h2>
        <p>Are you sure you want to delete this newsletter?</p>

        <br />

        <button className="Button" value="Unsubscribe" onClick={onSubmit}>
          Confirm
        </button>
        <br />
        <button className="Button" value="Unsubscribe" onClick={onCancel}>
          Cancel
        </button>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </div>
  );
}

export default withRouter(DeleteNewsletterConfirm);
